import React from 'react'
import Toast from '../../../components/Toast/Toast'
import ViewFormActivationMIPYME from './ViewFormActivationMIPYME'
import { FormContextProvider } from '../../../context/formContext'

const FormActivationMIPYME = () => {
  return (
    <>
      <FormContextProvider>
        <Toast />
        <ViewFormActivationMIPYME />
      </FormContextProvider>
    </>
  )
}

export default FormActivationMIPYME
